import { fg } from '@atlaskit/platform-feature-flags';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';

import {
	SainAction,
	useSAINUsageCriteriaMet,
} from '../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../common/controller/analytics/use-analytics';
import { FEEDBACK_ENTRYPOINT_ID_SAIN } from '../../constants';
import { useAIAnswerContext } from '../ai-answer-context';
import { onDislikeButtonClick, onLikeButtonClick } from '../analytics';

export function useSmartAnswerCardFeedbackOptions() {
	const { commonAttributes, readingAidsOptions, updateContextCache, userDetails } =
		useAIAnswerContext();
	const { query, errorState, searchSessionId, source, queryHash, cloudId, answerString } =
		commonAttributes;

	const [fireAnalyticsEvent] = useAnalytics();
	const { trackAIFeedbackSubmit } = useAIEventsInstrumentation();
	const { fireSAINUsageEvent } = useSAINUsageCriteriaMet();

	const onLikeButtonClickHandler = () => {
		updateContextCache({ collapsed: false, liked: true });
		fireAnalyticsEvent(onLikeButtonClick(commonAttributes));

		if (fg('kd_enable_new_usage_tracking')) {
			fireSAINUsageEvent({
				metCriteria: SainAction.POSITIVE_FEEDBACK_PROVIDED,
				commonAttributes,
			});
		} else {
			trackAIFeedbackSubmit('up');
		}
	};

	const onDislikeButtonClickHandler = () => {
		updateContextCache({ collapsed: false, liked: false });
		fireAnalyticsEvent(onDislikeButtonClick(commonAttributes));

		if (fg('kd_enable_new_usage_tracking')) {
			fireSAINUsageEvent({
				metCriteria: SainAction.NEGATIVE_FEEDBACK_PROVIDED,
				commonAttributes,
			});
		} else {
			trackAIFeedbackSubmit('down');
		}
	};

	const feedbackAttributes = {
		searchSessionId: searchSessionId,
		source: source,
		queryHash: queryHash,
		cloudId: cloudId,
		documentId: readingAidsOptions?.contentARI,
		errorState: errorState,
	};
	const feedbackAttributesWithConsent = {
		prompt: query,
		answer: answerString,
	};
	const feedbackOptions = {
		attributes: feedbackAttributes,
		attributesWithConsent: feedbackAttributesWithConsent,
		entrypointId: FEEDBACK_ENTRYPOINT_ID_SAIN,
		onLikeButtonClickHandler: onLikeButtonClickHandler,
		onDislikeButtonClickHandler: onDislikeButtonClickHandler,
		userDetails,
	};

	return feedbackOptions;
}
